import stateGenerator from './state-generator'
import * as actions from './actions'
import * as extraReducers from './extra-reducers'

const paginationFeature = {
  generator: {...stateGenerator},
  actions,
  extraReducers
}

export default paginationFeature
